import { useTriggerLoad } from "@redotech/react-util/load";
import { ReturnAppSettings } from "@redotech/redo-customer-portal-shared/settings";
import {
  ProductInfo,
  ShopifyStorefrontClient,
  searchProducts as searchStorefrontProducts,
} from "@redotech/shopify-storefront";
import { memo, useEffect } from "react";
import * as advancedExchange from "./advanced-exchange.module.css";
import { ExchangeProduct } from "./variant-bubbles";

export const SearchBar = memo(function SearchBar({
  settings,
  searchQuery,
  setSearchQuery,
  setDisplayingSearchResults,
  setSearchedItems,
  filterSearchProduct,
  getProductInfo,
  setSearchString,
  setSearchLoading,
}: {
  settings: ReturnAppSettings;
  searchQuery: string;
  setSearchQuery: (x: string) => void;
  setDisplayingSearchResults: (x: boolean) => void;
  setSearchedItems: (x: ExchangeProduct[]) => void;
  filterSearchProduct: (x: ExchangeProduct) => boolean;
  getProductInfo: (x: ProductInfo) => ExchangeProduct;
  setSearchString: (x: string) => void;
  setSearchLoading: (x: boolean) => void;
}) {
  const [searchProductsLoad, searchProducts] = useTriggerLoad(
    async (signal) => {
      if (searchQuery == "") {
        setDisplayingSearchResults(false);
        setSearchedItems([]);
        return;
      }

      const storefrontClient = new ShopifyStorefrontClient(
        settings.storeUrl,
        settings.storefrontAccessToken,
      );

      const response = await searchStorefrontProducts(
        storefrontClient,
        searchQuery,
        100,
      );
      const products = response.map(getProductInfo);
      const filteredProducts = products.filter(filterSearchProduct);

      setSearchedItems(filteredProducts);
      setSearchString(searchQuery);
      setSearchQuery("");
      setDisplayingSearchResults(true);
    },
  );

  useEffect(() => {
    setSearchLoading(searchProductsLoad.pending);
  }, [searchProductsLoad, setSearchLoading]);

  return (
    <form
      onSubmit={(e) => {
        e.preventDefault();
        searchProducts();
      }}
    >
      <div className={advancedExchange.searchBarContainer}>
        <input
          className={advancedExchange.searchBar}
          onChange={(e) => {
            setSearchQuery(e.target.value);
          }}
          placeholder="Search"
        />
        <svg
          className={advancedExchange.searchIcon}
          fill="none"
          height="20"
          onClick={(e) => {
            e.preventDefault();
            searchProducts();
          }}
          viewBox="0 0 16 16"
          width="20"
          xmlns="http://www.w3.org/2000/svg"
        >
          <g clipPath="url(#clip0_2403_21967)">
            <path
              d="M2.03417 8.85428C2.57367 10.1237 3.59535 11.1268 4.87446 11.643C6.15357 12.1591 7.58532 12.146 8.85476 11.6065C10.1242 11.067 11.1273 10.0453 11.6435 8.76623C12.1596 7.48712 12.1465 6.05536 11.607 4.78593C11.0675 3.5165 10.0458 2.51337 8.7667 1.99722C7.4876 1.48108 6.05584 1.4942 4.78641 2.0337C3.51697 2.57319 2.51385 3.59487 1.9977 4.87398C1.48156 6.15309 1.49468 7.58484 2.03417 8.85428Z"
              stroke="#181818"
              strokeLinecap="round"
              strokeLinejoin="round"
              strokeWidth="2"
            />
            <path
              d="M11 11L15 15"
              stroke="#181818"
              strokeLinecap="round"
              strokeLinejoin="round"
              strokeWidth="2"
            />
          </g>
          <defs>
            <clipPath id="clip0_2403_21967">
              <rect fill="white" height="16" width="16" />
            </clipPath>
          </defs>
        </svg>
      </div>
    </form>
  );
});
